import { useNodeCanvasStore } from '../../store';
import { Node } from './node';
import { CanvasItem, Position } from './canvasObjects';
import { MessageField } from './message';
import { v4 } from 'uuid';
import { V4UUID } from '@/firebase/database';
import { useGlobalStore } from '@/modules/globalModule/store';
export interface CustomSrvText {
  requestText: string;
  responseText: string;
}
export class Service implements CanvasItem {
  position: Position;
  id: V4UUID;
  name: string;
  radius: number;
  width: number;
  height: number;
  color: string;
  requestList: Array<MessageField> = [];
  responseList: Array<MessageField> = [];
  server: V4UUID | undefined; // Node id
  clients: V4UUID[]; // List of node ids
  packageId?: V4UUID;
  customText: CustomSrvText = {
    requestText: '',
    responseText: ''
  };
  constructor(
    id: V4UUID = v4(),
    x: number = 0,
    y: number = 0,
    name: string = '',
    radius: number = 15,
    width: number = 100,
    height: number = 150,
    color: string = '#2196F3',
    requestList: Array<MessageField> = [],
    responseList: Array<MessageField> = [],
    server: V4UUID | undefined = undefined, // Node id
    clients: V4UUID[] = [], // List of node ids
    parent: { id?: V4UUID } | undefined = undefined,
    packageId: V4UUID | undefined = undefined,
    customText: CustomSrvText | undefined = undefined
  ) {
    this.id = id;
    this.position = { x, y };
    this.name = name;
    this.radius = radius || 15;
    this.width = width || 100;
    this.height = height || 150;
    this.color = color || '2196F3';
    this.requestList = requestList || [];
    this.responseList = responseList || [];
    this.server = server;
    this.clients = clients || [];
    this.packageId = packageId;
    if (customText) this.customText = customText;
  }
  /**
   *
   * @param {Node} serviceServer
   */
  addServer(serviceServer: Node): void {
    if (!this.server) this.server = serviceServer.id;
  }
  removeServer(): void {
    this.server = undefined;
  }
  /**
   *
   * @param {Node} serviceClient
   * @returns
   */
  addClient(serviceClient: Node) {
    if (this.clients.find((ea) => ea === serviceClient.id) === undefined) {
      this.clients.push(serviceClient.id);
    }
  }
  removeClient(client: Node) {
    this.clients = this.clients.filter((id) => id !== client.id);
  }

  // TODO: move to drawCanvas
  drawArcs(
    stage: any,
    drawLineFunc: (stage: any, obj1: any, obj2: any) => void
  ) {
    const ncStore = useNodeCanvasStore();
    if (!ncStore.packageId) return;
    const globalStore = useGlobalStore();
    const serverObj = this.serverObj();
    let linesDrawn: Array<Position> = [];
    if (
      serverObj !== undefined &&
      globalStore.checkElemInPackage(ncStore.packageId, serverObj.id)
    ) {
      drawLineFunc(stage, this, serverObj);
      linesDrawn.push(serverObj.position);
    }
    for (let client of this.clientObjs()) {
      if (
        globalStore.checkElemInPackage(ncStore.packageId, client.id) &&
        !linesDrawn.includes(client.position)
      ) {
        drawLineFunc(stage, this, client);
        linesDrawn.push(client.position);
      }
    }
  }
  clientObjs(): Node[] {
    const globalStore = useGlobalStore();
    return this.clients
      .filter((client) => globalStore.getNode(client))
      .map((client) => globalStore.getNode(client) as Node);
  }
  serverObj() {
    const globalStore = useGlobalStore();
    if (!this.server) return;
    return globalStore.getNode(this.server);
  }
  static fromJSON(jsonSrv: any) {
    return new Service(
      jsonSrv.id,
      jsonSrv.position ? jsonSrv.position.x : jsonSrv.x,
      jsonSrv.position ? jsonSrv.position.y : jsonSrv.y,
      jsonSrv.name,
      jsonSrv.radius,
      jsonSrv.width,
      jsonSrv.height,
      jsonSrv.color,
      jsonSrv.requestList,
      jsonSrv.responseList,
      jsonSrv.server,
      jsonSrv.clients,
      jsonSrv.packageId,
      jsonSrv.customText
    );
  }
  getPosition: () => Position = () => this.position;
  setPosition = (x: number, y: number) => (this.position = { x: x, y: y });
}

// export class ServiceParameter {
//   id: string;
//   type: V4UUID; // number representing message id
//   name: string; // name of parameters
//   constValue: string | undefined; // value if parameter is constant, undefined if not constnat
//   rosPackage: string | undefined; // undefined if this package
//   constructor(
//     type: V4UUID,
//     name: string,
//     constValue: string | undefined = undefined,
//     rosPackage: string | undefined = undefined,
//     id: string = v4()
//   ) {
//     this.type = type;
//     this.name = name;
//     this.id = id;
//     this.constValue = constValue;
//     this.rosPackage = rosPackage;
//   }
// }
